<template>
    <the-nav>
        <h1>Usuarios de la aplicación</h1>

        <button class="btn btn-secondary" type="button" @click="this.modalToShow = 'add-user'"
                title="Nuevo usuario">
            <span>Añadir usuario</span>
        </button>
    </the-nav>

    <div class="admin-page text-center">
        <!--            <div class="admin-header">-->
        <!--                <button class="btn btn-secondary" type="button" @click="this.modalToShow = 'add-user'"-->
        <!--                        title="Nuevo usuario">-->
        <!--                    <span>Añadir usuario</span>-->
        <!--                </button>-->
        <!--            </div>-->

        <div class="admin-main">
            <v-table v-if="status === 'loaded'">
                <template v-slot:header>
                    <th class="fit">#</th>
                    <th>Nombre</th>
                    <th>Correo</th>
                    <th>Rol</th>
                    <th class="fit">Acciones</th>
                </template>

                <template v-slot:body>
                    <tr v-for="user in users">
                        <td class="fit">{{ user.id }}</td>
                        <td>{{ user.name }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ formatRoleName(user.role.name) }}</td>
                        <td class="fit">
                            <div class="actions-container">
                                <button class="btn btn-show" @click="showUser(user)">
                                    <i class="uq-icon bi-eye"></i>
                                </button>

                                <button class="btn btn-edit" @click="editUser(user)">
                                    <i class="uq-icon bi-pencil"></i>
                                </button>

                                <!--                                <button class="btn btn-delete" @click="deleteUser(user)">
                                                                    <i class="uq-icon bi-trash"></i>
                                                                </button>-->
                            </div>
                        </td>
                    </tr>
                </template>
            </v-table>

            <div v-if="status === 'loading'">
                <div class="loader-container">
                    <div class="loader"></div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="status === 'errorPermissions' && userLogged.roleName != 'Admin'">
        No tienes permisos
    </div>

    <users-list-show-modal v-if="modalToShow === 'show-user'" :user="selectedUser"
                           @closed="modalToShow = null"></users-list-show-modal>

    <users-list-edit-modal v-if="modalToShow === 'edit-user'" :user="selectedUser"
                           @closed="modalToShow = null; loadUsers();"></users-list-edit-modal>

    <users-list-delete-modal v-if="modalToShow === 'delete-user'" :user="selectedUser"
                             @closed="modalToShow = null; loadUsers()"></users-list-delete-modal>

    <users-list-add-modal v-if="modalToShow === 'add-user'"
                          @closed="modalToShow = null; loadUsers()"></users-list-add-modal>
</template>

<script>
import UsersListShowModal from "./parts/UsersListShowModal";
import UsersListEditModal from "./parts/UsersListEditModal";
import UsersListDeleteModal from "./parts/UsersListDeleteModal";
import UsersListAddModal from "./parts/UsersListAddModal";
import TheNav from "../layouts/TheNav";
import {getUsers} from "../../helpers/requests/RequestsUsers";
import VTable from "../general/VTable";

export default {
    name: "users-index",
    components: {
        TheNav,
        UsersListAddModal,
        UsersListDeleteModal,
        UsersListEditModal,
        UsersListShowModal,
        VTable
    },
    data() {
        return {
            status: 'loading',
            users: [],
            user: null,

            selectedUser: null,
            modalToShow: null
        }
    },
    computed: {
        userLogged() {
            return this.$store.state.user.userLogged;
        }
    },
    mounted() {
        this.loadUsers();
    },
    methods: {
        formatRoleName(name) {
            return name.charAt(0).toUpperCase() + name.slice(1).replaceAll('_', ' ');
        },
        async loadUsers() {
            try {
                this.users = await getUsers();
                this.status = 'loaded';

            } catch (e) {
                if (e.response.status === 403) {
                    this.status = 'errorPermissions';
                }
            }
        },
        showUser(user) {
            this.selectedUser = user;
            this.modalToShow = 'show-user';
        },
        editUser(user) {
            this.selectedUser = user;
            this.modalToShow = 'edit-user';
        },
        deleteUser(user) {
            this.selectedUser = user;
            this.modalToShow = 'delete-user';
        },
        addUser() {
            this.modalToShow = 'add-user';
        }
    }
}
</script>

